export const CRO_CHECKOUT_REASSURANCE_FLAG = "cro-checkout-reassurance-guarantee"

export type CheckoutReassuranceVariant = "control" | "reassurance_guarantee" | "unassigned"

export interface PostHogWithReassuranceFlags {
  getFeatureFlag: (key: string) => string | boolean | undefined
  onFeatureFlags?: (cb: () => void) => (() => void) | void
}

export function normalizeCheckoutReassuranceVariant(
  raw: string | boolean | undefined
): CheckoutReassuranceVariant {
  if (raw === "reassurance_guarantee") return "reassurance_guarantee"
  if (raw === "control") return "control"
  return "unassigned"
}
